import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import ar from './locales/ar.json';
import en from './locales/en.json';
import ur from './locales/ur.json';

export type SupportedLocale = 'ar' | 'en' | 'ur';

export const SUPPORTED_LOCALES: SupportedLocale[] = ['ar', 'en', 'ur'];
export const RTL_LOCALES: SupportedLocale[] = ['ar', 'ur'];

const fallbackLocale: SupportedLocale =
  (import.meta.env.VITE_DEFAULT_LOCALE as SupportedLocale | undefined) ?? 'ar';

function normalizeLocale(lng: string | undefined): SupportedLocale {
  return SUPPORTED_LOCALES.includes(lng as SupportedLocale)
    ? (lng as SupportedLocale)
    : fallbackLocale;
}

function applyDocumentLocale(lng: string | undefined) {
  const locale = normalizeLocale(lng);
  document.documentElement.lang = locale;
  document.documentElement.dir = RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr';
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
      ur: { translation: ur },
    },
    fallbackLng: fallbackLocale,
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'yusr.lang',
    },
    returnNull: false,
  })
  .then(() => applyDocumentLocale(i18n.resolvedLanguage ?? i18n.language));

i18n.on('languageChanged', applyDocumentLocale);

export function isRtlLocale(locale: string | undefined | null): boolean {
  if (!locale) return true;
  return RTL_LOCALES.includes(locale as SupportedLocale);
}

export default i18n;
